export default "/f/static/header_assets/img/atiNewYearSmall.png";